//import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
//import { Calendar, CalendarOptions, EventApi, FullCalendarComponent } from '@fullcalendar/angular'; // useful for typechecking
import { AfterViewInit, Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges, AfterContentInit, ViewRef, ViewContainerRef, TemplateRef } from '@angular/core';
import { Calendar, CalendarOptions, EventApi, FullCalendarComponent } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

@Component({
  selector: 'app-fullcalendar',
  templateUrl: './fullcalendar.component.html',
  styleUrls: ['./fullcalendar.component.css']
})

export class FullcalendarComponent implements OnChanges {

  @Input() EventList: string;
  @Input() StartDate: string;
  currentEvents: EventApi[] = [];

  calendarApi: Calendar;
  calendarValues = {
    StartDate: "",
    EndDate: ""
  };

  /***************************** End Variable *******************************/
  calendarOptions: CalendarOptions;
  @ViewChild('calendar') calendarComponent: FullCalendarComponent;

  ngOnChanges(): void {

    if (!!this.EventList) {
      var jsonEventList = JSON.parse(this.EventList);
      this.fullcalendarLoadEvent(jsonEventList);
    }
  }

  fullcalendarLoadEvent(data) {
    var eventobjectarray = [];
    data.forEach((traget, indextraget) => {
      var eventlistobject = {};
      eventlistobject['title'] = traget.Subject;
      eventlistobject['date'] = traget.StartDate;
      eventlistobject['id'] = traget.ProjectSalePlanningId;

      if (traget.ProjectSaleCustomerType == '53') {
        eventlistobject['backgroundColor'] = '#ffe0fc';
        eventlistobject['borderColor'] = '#ad6ca6';
        eventlistobject['textColor'] = '#ad6ca6';
        eventlistobject['textAlign'] = 'left';


      } else if (traget.ProjectSaleCustomerType == '54') {
        eventlistobject['backgroundColor'] = '#fef7e0';
        eventlistobject['borderColor'] = '#e4c455';
        eventlistobject['textColor'] = '#e4c455';

      } else if (traget.ProjectSaleCustomerType == '55') {
        eventlistobject['backgroundColor'] = '#d9f1ff';
        eventlistobject['borderColor'] = '#205a7e';
        eventlistobject['textColor'] = '#205a7e';

      } else {
        eventlistobject['backgroundColor'] = '#dee2e6';
        eventlistobject['borderColor'] = '#6c757d';
        eventlistobject['textColor'] = '#6c757d';
      }


      eventobjectarray.push(eventlistobject);

    });

    this.calendarOptions = {

      initialView: 'dayGridMonth',
      dayMaxEvents: true,
      events: eventobjectarray.reverse(),
      eventDisplay: 'block',
      eventColor: '#C4E1F3',
      eventBorderColor: '#205A7E',
      eventTextColor: '#000',
      displayEventTime: false,
      displayEventEnd: true,
      selectable: false,
      eventOrder: '-id',
      initialDate: this.StartDate,
      initialEvents: eventobjectarray[0],
      dateClick: this.handleDateClick.bind(this), // bind is important!
      navLinks: this.handleDateClick.bind(this) // can click day/week names to navigate views
    }


  }

  handleEvents(events: EventApi[]) {
    this.currentEvents = events;
  }

  handleDateClick(arg, traget, event) {

    const app = document.getElementById("app");
    const p = document.createElement("h3");
    var d = new Date(arg.date);
    p.textContent = d.getDate().toString();
    $(p).css('color', '#20A2C0')
    var arrDayInWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    let p2 = document.createElement("h4");
    let p3 = document.createElement("hr");

    p2.textContent = arrDayInWeek[d.getDay()];

    $(app).html("");
    $(app).html(p).append(p2).append(p3);



    this.calendarValues.StartDate = arg.dateStr;
    this.calendarValues.EndDate = "";
    
  }

  someMethod() {
    const calendarApi = this.calendarComponent.getApi();
    const currentDate = calendarApi.getDate();
    console.log("The current date of the calendar is " + currentDate);
  }
}
